export const getDateRangeOptions = (option: string) => {
  switch (option) {
    case 'last_7_days':
      return ['less_than', '7']
    case 'last_30_days':
      return ['less_than', '30']

    case 'all_time':
    default:
      return ['before', '']
  }
}

export const hasClickedOutside = (
  e: any,
  isDateRangePickerOpen: boolean,
  ref: any,
  toggleDateRange: any,
  dispatch: (arg0: any) => void,
  closeDateRangePicker: any,
) => {
  // If the picker is open and the clicked target is not within the picker, then close the picker
  if (
    isDateRangePickerOpen &&
    ref.current &&
    !ref.current.contains(e.target) &&
    toggleDateRange
  ) {
    dispatch(toggleDateRange(false))
  } else if (
    isDateRangePickerOpen &&
    ref.current &&
    !ref.current.contains(e.target) &&
    closeDateRangePicker
  ) {
    closeDateRangePicker()
  }
}
